import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const HomeWelcomeMessage: LoadableType<{
	onLoad?: () => void;
	noCollapse?: boolean;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-WelcomeMessage" */ './WelcomeMessage.tsx'))
			.HomeWelcomeMessage,
});
